import type { SdkOptions } from "../sdk";
import getSdkHost from "./getSdkHost";
import setDefaultHeaders from "./setDefaultHeaders";

// Every sportsmet service mounts its zones at /v1/<zone>: the default prefix
// makes SDK calls hit /v1/private/<resource>/<action>.
//
// Returns a NEW object rather than mutating the caller's: an app that keeps
// one options object and passes it to several sdk() calls must not have its
// own object rewritten underneath it.
export default function __setDefaultSdkOptions(
  options?: SdkOptions,
): SdkOptions {
  return {
    apiHost: options?.apiHost ?? getSdkHost(),
    prefix: options?.prefix ?? "/v1/private",
    headers: setDefaultHeaders({ headers: options?.headers }),
  };
}
